import {
  BusinessRedemptionReportResponse,
  QueryBusinessRedemptionReportArgs,
  UserSavingsResponse,
  QueryUserSavingsArgs,
  QueryReportingBusinessOverviewArgs,
  ReportingBusinessOverview
} from "@irati/types"
import {createUseQuery} from "@irati/utils/services/apollo"

import businessRedemptionReportQuery, {businessRedemptionReportKey} from "./services/queries/businessRedemptionReport"
import userSavingsQuery, {userSavingsKey} from "./services/queries/userSavings"
import showMaximiseUsageQuery, {showMaximiseUsageKey} from "./services/queries/showMaximiseUsage"

interface GetFullSavings {
  retrieveAllFields?: boolean
}

export const useBusinessRedemptionReport = createUseQuery<BusinessRedemptionReportResponse, QueryBusinessRedemptionReportArgs>(
  businessRedemptionReportQuery,
  {key: businessRedemptionReportKey}
)

export const useUserSavings = createUseQuery<UserSavingsResponse, QueryUserSavingsArgs & GetFullSavings>(userSavingsQuery, {key: userSavingsKey})

export const useShowMaximiseUsage = createUseQuery<ReportingBusinessOverview, QueryReportingBusinessOverviewArgs>(showMaximiseUsageQuery, {
  key: showMaximiseUsageKey
})
